export default __webpack_public_path__ + "static/media/ne.cb75972c.svg";